/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_Group_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Group" |
*
* @param {Team_Manager_Save_Group_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_group_button = /** @type {((inputs?: Team_Manager_Save_Group_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Group_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить группу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह को सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar grupo")
	return /** @type {LocalizedString} */ ("Save Group")
});